import { useCallback, useEffect, MutableRefObject } from 'react';

interface IVideoPlayerVolume {
  setVolume: (value: number) => void;
  toggleMute: () => void;
}

interface IVideoPlayerVolumeParams {
  videoRef: MutableRefObject<HTMLVideoElement | null>;
  playerConfig: {
    isMuted: boolean;
    volume: number;
  };
  onConfigUpdate: (params: { isMuted?: boolean; volume?: number }) => void;
}

export function useVideoPlayerVolume({
  videoRef,
  playerConfig,
  onConfigUpdate,
}: IVideoPlayerVolumeParams): IVideoPlayerVolume {
  const setVolume = useCallback((value: number) => {
    onConfigUpdate({
      volume: value,
      isMuted: !value,
    });
  }, []);

  const toggleMute = useCallback(() => {
    onConfigUpdate({ isMuted: !playerConfig.isMuted });
  }, [playerConfig.isMuted]);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.volume = playerConfig.volume;
    }
  }, [playerConfig.volume]);

  return { setVolume, toggleMute };
}
